// extracted by mini-css-extract-plugin
module.exports = {"empty-box":"empty-box__1EUtN","empty-box-embedded":"empty-box-embedded__35FLO"};